export { CUSTOMER_DRIVE_ROOT_FOLDER_ID as CUSTOMER_ROOT_FOLDER_ID } from "@/lib/integrations/google-drive/customer-root";

export interface ClientFolder {
  id: string;
  name: string;
  driveId?: string;
}

export interface UploadResult {
  filename: string;
  id: string;
  webViewLink: string;
}

export interface UploadError {
  filename: string;
  error: string;
}

export interface UploadResults {
  uploaded: UploadResult[];
  errors: UploadError[];
}

export interface Attachment {
  id: string;
  name: string;
  size?: number;
  mimeType?: string;
}
